// import './echo'
import './axios'
import './fontawesome'
import 'bootstrap'
import $ from 'jquery'

window.jQuery = window.$ = $
